// extracted by mini-css-extract-plugin
export default {"recordType":"EntitiesTable_recordType__Xlsls","recordTypeIcon":"EntitiesTable_recordTypeIcon__kin-f","actions":"EntitiesTable_actions__2AVQB","row":"EntitiesTable_row__ndNQB"};